import axios from "axios";
import api from "../api";

const multipartAuthConfig = () => ({
  headers: {
    "Content-Type": "multipart/form-data",
    Authorization: `Bearer ${localStorage.getItem("token")?.replace(/"/g, "") || ""}`,
  },
});

export const saveTemplateDocxGat = async (formData: FormData): Promise<boolean> => {
  const client = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
  });
  const result = await client.post(`/templates/docx`, formData, multipartAuthConfig());
  if (result.status === 200 || result.status === 201) {
    return true;
  }
  throw new Error("Não foi possível salvar o template DOCX");
};

export const getTemplateDocxGat = async (
  templateId: string,
  userId: string
): Promise<ArrayBuffer> => {
  const client = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
  });
  const result = await client.get(
    `/templates/${templateId}/docx?userId=${userId}`,
    {
      responseType: "arraybuffer",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")?.replace(/"/g, "") || ""}`,
      },
    }
  );
  return result.data;
};

export const updateTemplatesGat = async (data: any): Promise<any> => {
  const result = await api.put(`/templates`, data);
  if (result.status === 200) {
    return true;
  } else {
    throw new Error("Não foi possível cadastrar Assinantes");
  }
};

export const createTemplatesGat = async (data: any): Promise<any> => {
  const result = await api.post(`/templates`, data);
  if (result.status === 200) {
    return true;
  } else {
    throw new Error("Não foi possível cadastrar Assinantes");
  }
};

export const deleteTemplatesGat = async (id: string): Promise<boolean> => {
  const result = await api.delete(`/templates?Id=${id}`);
  if (result.status === 200) {
    return true;
  } else {
    throw new Error("Não foi possível cadastrar Assinantes");
  }
};

export const getTemplatesByUserIdGat = async (userId: string, page: number, rowsPerPage: number): Promise<any> => {

  let url = `/templates/get-all-templates?`;

  if (userId) {
    url = url + `userId=${userId}`;
  }

  if (page) {
    url = url + `&pageNumber=${page}`;
  }

  if (rowsPerPage) {
    url = url + `&pageSize=${rowsPerPage}`;
  }

  const result = await api.get(url);

  if (result) {
    return result;
  } else {
    throw new Error("Não foi possível cadastrar Assinantes");
  }
};

export const getTemplatesGat = async (id: string): Promise<any> => {
  const result = await api.get(`/templates/?Id=${id}`);
  if (result.status === 200) {
    return result;
  } else {
    throw new Error("Não foi possível cadastrar Assinantes");
  }
};